import { render, staticRenderFns } from "./About.vue?vue&type=template&id=54e1e86d&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=54e1e86d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e1e86d",
  null
  
)

export default component.exports